import { cifAe, cifEg } from "@coreui/icons";
import { colors } from "../../src/utils/const";
import { userAgent } from "@/utils/generalUrils";
import Box from "@mui/material/Box";
export default {
  terms: "https://contact.eg/terms-and-conditions-en.pdf",
  contact: "Contact",

  contact_supervision:
    "Under the supervision of the Financial Regulatory Authority (FRA) license number 756, Date 18/04/2018",
  partner_types: [
    { id: "1", title: "Leasing Partners" },
    { id: "2", title: "Factoring Partners" },
    { id: "3", title: "Business Partners" },
    // { id: "4", title: "ContactNow Merchant" },
  ],
  CategoriesForm1: [
    "Appliances & Electronics",
    "Travel & Entertainment",
    "Automotive",
    "Appliances",
    "Mobiles and Tables",
    "Home & Furniture",
    "Fashion",
    "Jewelry",
    "Health",
    "Beauty",
    "Family & Pets",
    "Education & Learning",
    "Services",
    "Sports & Well-Being",
    "Supermarkets & Hypermarkets",
    "Food & Beverage",
    "Home",
    "Department Stores & Marketplaces",
    "Gifts",
    "Businesses",
  ],
  POSform1: [
    "Paymob",
    "Paytabs",
    "Fawry",
    "Geidea",
    "Kashier",
    "Network International (NI)",
    "Other",
  ],
  form_title1: "ContactNow Merchant",
  form_sub1: "More Customers, Faster Turnarounds",
  form_des1:
    " With an intimate understanding of the Egyptian market and a professional, experienced and hardworking team, we’ll help you unlock your business’s true potential and provide you with access to ready, willing,and vetted customers. And our simple process and comprehensive plans will help you close more deals and move more of your products to the market.",
  form_title2: "Leasing Partners ",
  form_sub2: "Contact Medical Equipment Supplies",
  form_des2:
    "Get the equipment, vehicles, and your business needs through payment plans that suit your needs, with the option to own the assets at the end of the lease.",
  form_title3: "Factoring Partners",
  form_sub3: "Contact supplies cars and transport equipment",
  form_des3:
    "With Contact’s factoring solutions, turn your credit sales into cash today to meet your business needs and support your next step.",
  form_title4: "Business Partners",
  form_sub4: "Supply of diverse products and services",
  form_des4:
    "List your business with Contact — If you are offering any other products or services and you want to offer your customers and potential buyers the ease and convenience of payment plans and financing options from Contact, please fill the form and a representative will contact you. ",
  yes: "Yes",
  no: "No",
  have_record: "Do you have commercial register and tax id?",
  company_nameForm1: "Company / Organization name",
  company_nameForm3: "Business name",
  company_nameForm2: " Business name",
  full_name: "Full name of contact person",
  business_name: "Business name",
  specialist_name: "Contact person name",
  phone: "Phone number",
  email: "Email",
  categories: "Categories",
  url: " Site or Facebook link",
  address: "Detailed Address",
  governorate: "Governorate",
  branchesNumber: "Number of branches ",
  employees_number: "Number of employee ",
  field: "Business industry",
  digital: "Ecommerce",
  POS: "Point of sale (P.O.S)",
  send: "Submit",
  plans: "Installment Plans",
  popup: (
    <>
      <p style={{ marginBottom: "6px" }}>Go beyond the borders with Contact!</p>
      <p>Buy in Egypt, and pay from UAE</p>
    </>
  ),
  popup_img:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ramdankareem2026.webp",
  popup_img_mob:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/ramdankareem20226-2.webp",
  contact_now_btn: "Your installments and points",
  last_offers: "Latest Offers",
  exclusive: "Exclusive For You",

  incomeManagement: {
    fisrt_section: {
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/cash-mangement.webp",
      title: "Fixed Income Portfolio Management",
      subTitle: "Your Trusted Partner in Egypt's Debt Capital Markets (DCM)",
      pg: `Contact has a long and successful history in Egypt's Debt Capital Markets (DCM), making us the leading player in the industry. We leverage our extensive experience to offer a comprehensive suite of structured financing solutions, helping businesses thrive and achieve their financial goals.  
      
Our DCM services include securitization, Sukuk issuance, promotion and underwriting. Throughout our DCM services, we prioritize portfolio value protection against excessive market fluctuations, ensure adequate liquidity levels, diversify instrument structure, debt originator, and duration, and achieve competitive, optimized returns through active management strategies.`,
    },
    second_section: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/benefits.webp",
      title: "Milestones",
      pg: `Contact has been a pioneer and a market leader in the DCM space in Egypt since 2005. We have arranged and issued more than EGP 26 billion in debt issuances, including the very first securitization bond offering of its kind on the domestic market. We are also the first licensed sukuk issuer in the Egyptian market, offering Sharia-compliant financing solutions.
     
     Contact has also issued the first securitization bond backed by real-estate receivables ¬in the market in 2015, managed to be the leading issuer of Sukuk al-Mudarabah in 2021. Contact also issued the first Consumer Finance bond in 2022 with the highest portfolio rating in the market.`,
    },
    third_section: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/3.png",
      title:
        "By Choosing Contact As Your DCM Financial Partner, You Will Benefit From",
      list: [
        "Our extensive experience and expertise in the DCM field.",
        "Our strong relationships with regulators, rating agencies, investors, and other market participants.",
        "Our innovative and customized solutions that suit your unique needs.",
        "Our competitive pricing and flexible payment options.",
        "Our professional and dedicated team that will guide you throughout the entire process.",
      ],
    },
    outro:
      "Contact us today to find out how we can help you with your DCM inquiries and needs.  ",
  },

  //^ income trading
  incomeTrading: {
    fisrt_section: {
      title: "Fixed Income Instrument",
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/ss.webp",
    },
    second_section: {
      first_title: "Securitization",
      fisrt_subtitle: "Experience Matters",
      fisrt_pg: `Securitization is one of the widely commonly structured debt security issues with the purpose of transferring receivables to an SPV as collateral for third party investment. Choosing securitization as a structure has multiple advantages such as enhancing credit rating of underlying asset, Tax savings, Lower cost of capital, off-balance sheet financing and Source of liquidity.

Experience Matters: Since 2005, Contact has been a trusted partner in securitization in Egypt, guiding partners and clients through every step of the process. With extensive experience and a deep understanding of the market, Contact tailors solutions to your specific needs and navigates the complexities of securitization to achieve your financial goals.`,

      second_title: "Sukuk",
      second_subtitle: "Compliant with Shariah Principles",
      second_pg: `Sukuk are an asset-based security that represent aggregate and undivided shares of ownership and/or rights in a tangible asset as it relates to a specific project or a specific investment activity with Off-balance sheet advantage via SPV and Long duration. 

Hybrid instruments that share features that can be more debt-like or equity-like, depending on the structure.

Potential for a large and diverse investor base with highly flexible structures including: (Mudarabah, Musharaka, Ijara and Murabaha)

We offer comprehensive Sukuk Issuance Services in Egypt to help you navigate the process to ensure your needs are met from start to finish.`,
    },
  },

  //^ investment fund
  download: "Download the app",
  direction: "ltr",
  textAlign: "left",
  contact_us_title: "We Would Like To Hear From You!",
  formMsg: "Form Submitted Successfully",
  formMsgFail: "Form submission Failed",
  referralCodeErrorMsg:
    "Please verify the referral code before proceeding with the application.",
  clipboardMsg: "Link copied successfully",
  subscribeMsg: "Subscription done successfully",
  subscribeFailMsg: "Subscription failed",
  insurance_companies_title: "Corporate Insurance Products Sectors",
  insuranceFeatures_companies: [
    "Motor and fleet insurance",
    "Liability and causality",
    "property insurance",
    "Engineering insurance",
    "Marine & inland cargo insurance",
    "Medical insurance",
    "Saving and investment",
  ],
  calcTitle: "Calculate Your Installments",
  purpose: "Financing Plan",
  purpose2: "Financing Purpose",

  calc: {
    monthlyAmount: "The monthly amount",
    priceCar: "Financing Amount ",
    preAmount: "Down-payment",
    plan: "Plan",
    purpose: "Financing Purpose",
    egyptianPound: "EGP",
    duration: "Duration",
    month6: "6 month",
    months: "months",
    years: "{{count}} years",
    year1: "1 Year",
    year2: "2 Year",
    year3: "3 Year",
    year4: "4 Year",
    year5: "5 Year",
    year6: "6 Year",
    year7: "7 Year",
    year8: "8 Year",
    year9: "9 Year",
    year10: "10 Year",
    plan1: "Economic Programme",
    plan2: "Flexible Program",
    amount: "Financing Amount",
    downPaymentRange: "Value must be between {{min}} and {{max}}",
  },
  calc_packages: {
    consumer_finance: [{ packageId: 408, title: "Creditech" }],
  },
  general: {
    gifs: { hi: "/gif/hi-en.gif", calculationg: "/gif/calculating-en.gif" },
    popup:
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/popup-en.webp",
    menu: {
      about_us: "About Us",
      blog: "Blogs",
      careers: "Careers",
      contact_uae: "Contact UAE",
      our_brand: "Our Brands",
      contact_us: "Contact Us",
      investor_relations: "Investor Relations",
      sustainability: "Sustainability",
      why_contact: "Why Contact ?",
      payment_channels: "How to Pay Your Installments?",
    },
    reviewTitle: "Customers Review",
    reviewSubTitle: "What do customers say about us?",
  },
  logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/logo-en.webp",

  main_nav: {
    individuals: "Individuals",
    companies: "Business",
    investors: "Investors",
    lang: "عربي",
  },
  secondary_nav: {
    financial_services: "Financing Services",
    insurance_services: "Insurance Services",
    contact_uae: "Contact UAE",
    contact_now: "ContactNow",
    about_contact: "About Contact",
    about_contact_dropdown: [
      {
        url: "/about",
        color: colors.ratty,
        img: "/sideDrawer/About_Us_icon.svg",
        title: "About Us",
      },
      {
        url: "/our-brands",
        color: colors.ratty,
        img: "/sideDrawer/our_brands_icon.svg",
        title: "Our Brands",
      },
      {
        url: "/contact-us",
        color: colors.ratty,
        img: "/sideDrawer/Contact_us_Icon.svg",
        title: "Contact Us",
      },
    ],
    payment_channels: "How to Pay Your Installments?",
    blog: "Blogs",
    careers: "Careers",
    investor_relations: "Investor Relations",
    sustainability: "Sustainability",
    e_payments: "Bill Payments",
    why_contact: "Why Contact ?",
    clients_program: "Contact Catalogue",
    offers: "Offers",
    branches_location: "Our Branches",
    login: "Login",
    download_app: "Download App",
    insurance_services_dropdown: [
      {
        url: "/products/insurance",
        color: colors.ratty,
        img: "/services/contact-insurance-en.png",
        title: "Insurance Brokerage",
      },
      {
        url: "/sarwa-life",
        color: colors.ratty,
        img: "/services/sarwa-life-en.png",
        title: "Sarwa Life",
      },
      {
        url: "/sarwa-insurance",
        color: colors.ratty,
        img: "/services/sarwa-insurance-en.png",
        title: "Sarwa Insurance",
      },
    ],
  },
  footer: {
    section_a: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/subscribe.svg",
      subscribe_now:
        "Please enter a valid email address, and we’ll send you all the latest offers and updates directly to your inbox!",
      in_email_service: "In E-mail Service",
      enter_email: "info@gmail.com",

      button: "Subscribe",
      loading: "Sending...",
    },
    section_b: {
      for_individuals: "For Individuals",
      financial_services: "Financing Services",
      insurance_services: "Insurance Services",
      Terms_and_Conditions: "Terms and Conditions",
      list1: [
        { id: "1", name: "Auto", url: "/products/auto" },
        { id: "2", name: "Trucks", url: "/products/trucks" },
        { id: "3", name: "Shopping", url: "/products/contact-now" },
        { id: "4", name: "Education", url: "/products/education" },
        { id: "5", name: "Clubs", url: "/products/clubs" },
        { id: "6", name: "Maintenance", url: "/products/maintainance" },
        { id: "8", name: "Mortgage", url: "/products/mortgage" },
        { id: "9", name: "Motorcycles", url: "/products/motorcycles" },
        { id: "10", name: "Green Finance", url: "/products/green-finance" },
        { id: "11", name: "Factoring", url: "/products-bussiness/factoring" },
        { id: "12", name: "Leasing", url: "/products-bussiness/leasing" },
        { id: "13", name: "Home Interior", url: "/products/home-interior" },
        { id: "14", name: "Home Furniture", url: "/products/home-furniture" },
        { id: "15", name: "Watercraft", url: "/products/watercraft" },
      ],
      list2: [
        { name: "Insurance Brokerage", url: "/products/insurance" },
        {
          name: "Sarwa Life",
          url: "/sarwa-life",
        },
        {
          name: "Sarwa Insurance",
          url: "/sarwa-insurance",
        },
      ],
      list3: [{ name: "Bill Payments", url: "/e-payment" }],
      for_business: "For Business",
      for_business_list: [
        { name: "Referral Program", url: "/referral-program" },
      ],
      contact: "About Contact",
      contact_list: [
        { name: "About Us", url: "/about" },
        { name: "Our Brands", url: "/our-brands" },
        { name: "Why Contact ?", url: "/why-contact" },
        { name: "Careers", url: "/careers" },
        { name: "Contact UAE", url: "/contact-uae" },
        {
          name: "Investor Relations",
          url: "https://investorrelations.contact.eg/",
        },
        { name: "Sustainability", url: "/sustainability" },
        { name: "Blogs", url: "/blogs" },
        { name: "Media and News", url: "/media" },
      ],
      contact_us: "Contact Us",
      contact_us_list: [
        {
          name: "Contact Catalogue",
          url: `https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Contact-Catalogue.pdf`,
        },
        { name: "Our Branches", url: "/our-branches" },
        { name: "Our Hotline: 16177", url: "" },
        { name: "How to Pay Your Installments?", url: "/payment-channels" },
      ],
      privacy: "Privacy",
      privacy_list: [{ name: "Privacy Policy", url: "/privacy-policy.pdf" }],
      protection_guide: "Customer Protection Guide",
      protection_guide_list: [
        {
          name: "Guide 1",
          url: "https://fra.gov.eg/%D8%AF%D9%84%D9%8A%D9%84-%D8%AD%D9%85%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%AA%D8%B9%D8%A7%D9%85%D9%84%D9%8A%D9%86-%D9%81%D9%8A-%D8%A7%D9%84%D9%82%D8%B7%D8%A7%D8%B9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/",
        },
        {
          name: "Guide 2",
          url: `${process.env.NEXT_PUBLIC_SITE_URL}كتاب دورى رقم (4) .pdf`,
        },
      ],
    },
    section_c: {
      download_app: "Download Contact App",
      img1: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/google-play-en.png",
      img2: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/app-store-en.png",
      img3: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/huawei-store-en.jpg",
    },
    section_d: {
      copy_right1: "Copyright ",
      copy_right2: " © – All rights reserved to Contact",
    },
  },
  form_labels: {
    title: "Merchant Network",
    full_name: "Full Name",
    last_name: "Last Name",
    email_adress: "Email Address",
    phone_number: "Mobile Number",
    national_id: "National ID Number",
    governorate: "Governorate",
    g_placeholder: "Choose Governorate",
    referralCode: "Referral Code",
    category: "Category",
    city: "City",
    country: "Country",
    country_placeholder: "Choose Country",

    case1: "Please Choose at least a Category and a City",
    case2: "No Merchant Available",
    cat_placeholder: "Choose A Category",
    city_placeholder: "Choose A City",
    area_placeholder: "Choose An Area",
    area: "Area",
    a_placeholder: "Choose Area",
    car_type: "Car Type",
    car_placeholder: "Choose Car Condition",
    car_price: "Car Price",
    products: "Products",
    products_placeholder: "Choose A Product",
    offers_placeholder: "Choose Offer",
    offers_label: "Offers",
    mortgage_type: "Mortgage Type",
    POS_Placeholder: "Choose P.O.S",
    submit: "Submit",
    subject: "Subject",
    message: "How can we help you?",
    job: "The job applied for",
    resume: "Resume",
    resume_des: "Please upload your CV link",

    passport_copy: "Valid Passport Copy",
    work_permit: "Work Permit",
    hr_letter: "Stamped HR Letter",
    bank_statement: "Bank Statement",
    EgyptAddress: "Residence Address within Egypt",
    noFileChosen: " No File Chosen",
    chooseFile: "choose File",
    terms:
      " By checking this box, I give Contact Credit the authority and consent to disclose the data and information relating to me or the credit facility and the obligations in relation there-to and any default if any to the Egyptian Credit Bureau Company (I-Score). This includes checking my I-score report, which may be required for the request to be approved. Also, I accept any inquiry conducted about me by Contact Credit’s employees without objection from me.",
    enterPhoneFirst: "Please enter your phone number first",
    Disclaimer:
      "Uploading more documents can help expedite your approval process.",
    Disclaimer2: "For faster approval process",
    apply: "Apply for job",
    showmore: "Show more",
    optional: "Optional",
    edit: "Edit",
    save: "Save ",
    cancel: "Cancel",
    secondPhone: "Second Phone",
    additionalP: "Reference number",
    additionalN: "Reference name",
    preferredCallingTime: "Preferred Calling Time ",
    time_placholder: "Choose time",
    submit_form: "submit form",
    request_service: "Request Service",
  },
  governorates: [
    {
      id: "1",
      governorate_name: "Cairo",
    },
    { id: "2", governorate_name: "Giza" },
    {
      id: "3",
      governorate_name: "Alexandria",
    },
    {
      id: "4",
      governorate_name: "Dakahlia",
    },
    {
      id: "5",
      governorate_name: "Red Sea",
    },
    {
      id: "6",
      governorate_name: "Beheira",
    },
    {
      id: "7",
      governorate_name: "Fayoum",
    },
    {
      id: "8",
      governorate_name: "Gharbiya",
    },
    {
      id: "9",
      governorate_name: "Ismailia",
    },
    {
      id: "10",
      governorate_name: "Menofia",
    },
    {
      id: "11",
      governorate_name: "Minya",
    },
    {
      id: "12",
      governorate_name: "Qaliubiya",
    },
    {
      id: "13",
      governorate_name: "New Valley",
    },
    {
      id: "14",
      governorate_name: "Suez",
    },
    {
      id: "15",
      governorate_name: "Aswan",
    },
    {
      id: "16",
      governorate_name: "Assiut",
    },
    {
      id: "17",
      governorate_name: "Beni Suef",
    },
    {
      id: "18",
      governorate_name: "Port Said",
    },
    {
      id: "19",
      governorate_name: "Damietta",
    },
    {
      id: "20",
      governorate_name: "Sharkia",
    },
    {
      id: "21",
      governorate_name: "South Sinai",
    },
    {
      id: "22",
      governorate_name: "Kafr Al sheikh",
    },
    {
      id: "23",
      governorate_name: "Matrouh",
    },
    {
      id: "24",
      governorate_name: "Luxor",
    },
    { id: "25", governorate_name: "Qena" },
    {
      id: "26",
      governorate_name: "North Sinai",
    },
    {
      id: "27",
      governorate_name: "Sohag",
    },
  ],
  country: [
    {
      id: "Egypt",
      country_name: "Egypt",
      phoneCode: "+20",
      flag: "EG",
      icon: cifEg,
    },
    {
      id: "United Arab Emirates",
      country_name: "United Arab Emirates",
      phoneCode: "+971",
      flag: "AE",

      icon: cifAe,
    },
  ],

  car_type: [
    {
      id: "1",
      value: "New",
    },
    { id: "2", value: "Used" },
  ],
  preferredCallingTime: [
    "9:00 AM to 12:00 PM",
    "12:00 PM to 3:00 PM",
    "3:00 PM to 6:00 PM",
    "6:00 PM to 9:00 PM",
  ],
  mortgage_type: [
    {
      id: "1",
      value: "Home Finance",
    },
    { id: "2", value: "Home Equity" },
  ],
  home_page: {
    slides: [
      {
        bgColor: "#EAEAEA",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-en.svg",

        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-en-white.png",
        text: `
        <h1>
        One stop shop for your Financial and Insurance solutions
        </h1>
        `,
        textColor: colors.white,

        button: "Browse Products",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/one-shop-banner.webp",
        alt: "finance with contact",
        link: "/products",
      },
      {
        bgColor: "#EAEAEA",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-en.svg",

        logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-brokerage-en-light.webp",
        text: "Download the App & enjoy exclusive insurance benefits",
        textColor: colors.white,

        button: "Request service",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brokrage-banner.webp ",
        alt: "insurance brokerage",
        link: "/products/insurance",
        app: {
          google_play_link:
            "https://play.google.com/store/apps/details?id=com.insuranceBrokerage&hl=en",
          app_store_link:
            "https://apps.apple.com/eg/app/insurance-brokerage/id6445921286",
          qr_code:
            "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance_brokerage_qr_code.webp",
        },
      },
      {
        bgColor: "#2D317F",
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bg-banner-en.svg",
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact.png",
        text: "Everywhere around you",
        textColor: colors.white,
        button: "Pick Your Branch",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cover_img_22-en.png",
        alt: "contact branches",
        link: "/our-branches",
      },
    ],
    sec_navigation: [
      { title: "Our Branches", url: "/our-branches" },
      { title: "Blogs", url: "/blogs" },
      {
        title: "Contact Catalogue",
        url: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Contact-Catalogue.pdf",
      },
      { title: "Offers", url: "/our-offers" },
    ],
    services_title: "Our Services",
    products_title: "Our Products",
    products: [
      {
        optionId: "1",
        title1: "",
        title2: "Auto",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cars-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cars-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "Auto",
        alt: "auto background",
      },
      {
        optionId: "1",
        title2: "Motorcycles",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/motorcycle-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/motorcycles",
        value: "Motorcycles",
        alt: "motorcycles background",
      },
      {
        optionId: "1",
        title2: "Trucks",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/trucks-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/trucks",
        value: "Trucks",
        alt: "trucks background",
      },
      {
        optionId: "1",
        title2: "Watercraft",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/watercraft-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/watercraft",
        value: "Watercrafts",
        alt: "watercraft background",
      },
      {
        optionId: "2",
        title2: "Mortgage",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/home-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/mortgage",
        value: "Mortgage",
        alt: "mortgage background",
      },
      {
        optionId: "2",
        title2: "Home Interior",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/finishing-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/finishing-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/home-interior",
        value: "Homes",
        alt: "home interior background",
      },
      {
        optionId: "2",
        title2: "Home Furniture",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/furniture-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/home-furniture",
        value: "HomeFurniture",
        alt: "furniture background",
      },
      {
        optionId: "5",
        title2: "Education",
        img: "/pages/schools.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/schools-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title2: "Clubs",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/clubs-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/clubs",
        value: "Clubs",
        alt: "clubs background",
      },
      {
        optionId: "5",
        title2: "Shopping",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cart.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/cart-small.webp",
        bgcolor: "#fff",
        url: "/products/contact-now",
        value: "shopping",
        alt: "shopping background",
      },
      {
        optionId: "2",
        title2: "Maintenance",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintainance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/maintainance-cover-small.webp",
        bgcolor: "#fff",
        url: "/products/maintainance",
        value: "Maintenance",
        alt: "maintenance background",
      },

      {
        optionId: "3",
        title2: "Insurance Brokerage",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-cover-small-en.webp",
        bgcolor: "#fff",
        url: "/products/insurance",
        value: "Brokerage",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "Sarwa Life",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa-life.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-life-small-en.webp",
        bgcolor: "#fff",
        url: "/sarwa-life",
        value: "Life",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "Sarwa Insurance",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/brand-sarwa-insurance.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-insurance-small-en.png",
        bgcolor: "#fff",
        url: "/sarwa-insurance",
        value: "Insurance",
        alt: "insurance background",
      },
      {
        optionId: "4",
        title2: "Nursery",
        img: "/pages/nursery.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/nursery-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title2: "Schools",
        img: "/pages/schools.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/schools-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title2: "Universities",
        img: "/pages/universities.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/universities-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "4",
        title2: "Post Grad",
        img: "/pages/postgraduate.png",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/postgraduate-small.webp",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "6",
        title2: "Green Car",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-car-small.webp",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "Solar Panels",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-energy-small.webp",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "Greenhouses",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-house-small.webp",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "Irrigation systems",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-finance-cover.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/green-watering-small.png",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "7",
        title2: "Travel and Tourism",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/travel+and+tourism+640x640.webp",
        small_img:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/travel+and+tourism+640x640.webp",
        bgcolor: "#fff",
        url: "/products/travel-and-tourism",
        value: "Manasik",
        alt: "manasik",
      },
      {
        title2: "Factoring",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/factoring-cover.webp",
        bgcolor: "#bf6340",
        url: "/products-bussiness/factoring",
        value: "Factoring",
        alt: "factoring background",
      },
      {
        title2: "Leasing",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/leasing-cover.webp",
        bgcolor: "#4aa2a6",
        url: "/products-bussiness/leasing",
        value: "Leasing",
        alt: "leasing background",
      },
    ],
    bos: {
      title1: "Bill Payments",
      subtitle: "Your All-in-One Payment Solution",
      body1:
        "Now with Contact Pay, you can easily and securely pay your mobile, electricity, gas, water bills and many other services at one place, through ContactNow mobile application or Contact branches all over Egypt.",

      body2: [
        "Schools and universities tuition fees",
        "Electricity bills",
        "Gas bills",
        "Water bills",
        "Landline bills",
        "Mobile recharging and bills",
        "Internet subscription",
        "Transportation tickets",
        "TV subscriptions",
        "Insurance installments",
        "Donations and NGOs",
        "Clubs membership",
      ],
      WithContactPay_list: {
        title: "What can you do with Contact Pay?",
        list: [
          "Electricity bills",
          "Gas bills",
          "Water bills",
          "Landline bills",
          "Mobile recharging and bills",
          "Internet subscription",
          "Transportation tickets",
          "TV subscriptions",
          "Insurance installments",
          "Donations and NGOs",
          "Clubs membership",
          "Schools and universities tuition fees",
        ],
      },
      benefits: {
        title: "Your Convenience Is Our Priority",
        list: [
          "Speed and ease: Say goodbye to time-consuming bill payments. Contact Pay makes it quick and simple to settle your dues.",
          "Security you can trust: Rest assured; your transactions are protected by Contact's advanced security measures.",
          "One-stop solution: Ditch juggling multiple payment platforms. Contact Pay lets you manage all your bills seamlessly in one place.",
        ],
      },
      outro: (
        <p>
          Contact Pay is your answer to a simpler, more efficient way to manage
          your finances.Start enjoying the benefits today! Contact us or visit
          any of our branches to learn more and experience the convenience of
          Contact Pay. Together, let's pay smarter, not harder.{" "}
          <p style={{ paddingTop: "16px" }}>
            {" "}
            <a
              target="_blank"
              style={{ color: "#F18222", fontWeight: "600" }}
              href={userAgent(
                "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088",
                "https://play.google.com/store/apps/details?id=eg.contact",
              )}
            >
              Download the App now!{" "}
            </a>{" "}
          </p>
        </p>
      ),
    },
    services: {
      A: [
        {
          id: "1",
          url: "/products/auto",
          color: colors.blue,
          img: "/services/car.svg",
          title: "Auto",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "7",
          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "Motorcycles",
        },
        {
          id: "2",
          url: "/products/trucks",
          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "Trucks",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "15",
          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "Watercraft",
        },
        {
          id: "9",
          url: "/products/mortgage",
          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "Mortgage",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "14",
          url: "/products/home-interior",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "Home Interior",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "13",
          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "Home Furniture",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
      ],
      B: [
        {
          id: "4",
          url: "/products/education",
          color: colors.green,
          img: "/services/education.svg",
          title: "Education",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "5",
          url: "/products/clubs",
          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "Clubs",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "3",
          url: "/products/contact-now",
          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "Shopping",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "6",
          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "Maintenance",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "12",
          url: "/products/green-finance",
          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "Green Finance",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "16",
          url: "/products/travel-and-tourism",
          color: "#27A9E1",
          img: "/services/travel-tourism.svg",
          title: "Tourism and travel",
        },

        {
          id: "10",
          url: "/products-bussiness/factoring",
          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "Factoring",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "11",
          url: "/products-bussiness/leasing",
          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "Leasing",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
      ],
      All: [
        {
          id: "1",
          url: "/products/auto",
          color: colors.blue,
          img: "/services/car.svg",
          title: "Auto",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "7",
          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "Motorcycles",
        },
        {
          id: "2",
          url: "/products/trucks",
          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "Trucks",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "15",
          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "Watercraft",
        },
        {
          id: "9",
          url: "/products/mortgage",
          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "Mortgage",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "14",
          url: "/products/home-interior",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "Home Interior",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "13",
          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "Home Furniture",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "4",
          url: "/products/education",
          color: colors.green,
          img: "/services/education.svg",
          title: "Education",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "5",
          url: "/products/clubs",
          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "Clubs",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "3",
          url: "/products/contact-now",
          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "Shopping",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "6",
          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "Maintenance",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "12",
          url: "/products/green-finance",
          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "Green Finance",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "16",
          url: "/products/travel-and-tourism",
          color: "#27A9E1",
          img: "/services/travel-tourism.svg",
          title: "Tourism and travel",
        },

        {
          id: "10",
          url: "/products-bussiness/factoring",
          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "Factoring",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
        {
          id: "11",
          url: "/products-bussiness/leasing",
          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "Leasing",
          description:
            "If you need to develop your agricultural investment, Contact believes that agriculture development.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
      ],
      C: [
        {
          url: "/referral-program",
          color: colors.blue,
          img: "/services/clients.svg",
          title: "Referral Program",
          description: "If you need to develop your agricultural investment.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
      ],
      D: [
        {
          url: "/rewards",
          color: colors.blue,
          img: "/services/clients.svg",
          title: "Referral Program",
          description: "If you need to develop your agricultural investment.",
          full_description:
            "Are you looking for a way to grow your agricultural or renewable energy investments? Green Finance from Contact will support your investments with flexible and affordable plans. ",
        },
      ],
    },
    news_title: "Our News",
    news_button1: "Read More",
    news_button2: "More",
    news: [
      {
        id: "1",
        img: "/news/news1.png",
        title: "كونتكت تطلق منتج رقمي لتأمين السيارات",
        description:
          "كونتكت المالية القابضة تعلن اليوم عن إطلاق منتج رقمي بالكامل للتأمين التكميلى للسيارات في مصر. يتوفر المنتج من خلال منصة كونتكت كارز دوت كوم وشركة ثروة للتأمين وشركة كونتكت ...",
      },
      {
        id: "2",
        img: "/news/news2.png",
        title:
          "«شطبلي» توقع اتفاقية شراكة مع «كونتكت» لإتاحة برامج تمويل مبتكرة",
        description:
          "وقّعت شركة «شطبلي»، صاحبة أول منصة إلكترونية متخصصة في أعمال تصميم وتنفيذ أعمال الديكورات والتشطيبات، اتفاقية شراكة مع شركة كونتكت للتمويل ...",
      },
      {
        id: "3",
        img: "/news/news3.png",
        title: "كونتكت توقع برنامج تمويل فريد من نوعه في مصر مع كابيتر",
        description:
          "وقعت كونتكت المالية القابضة (CNFN)، الشركة الرائدة في مجال الخدمات المالية غير مصرفية في مصر، من خلال شركة كونتكت للتخصيم، أحد ...",
      },
    ],
    payment_channels: {
      title: "How to pay your installment with Contact",
      titleMob: "How to pay your installment?",
      description: `
            <p>Make your payment experience easier than ever!</p>
            <p>
              With Contact, you can pay your installments online, at your nearest payment point, 
              or through our branches—all in a few simple steps that save you time.<br />
              Visit your 
              <a href="/our-branches" style="color:#2D317F; font-weight:600; text-decoration:none;">
                nearest branch
              </a>
              or complete your payments quickly and securely through the 
              <a 
              href="https://onelink.to/frpjkg"
              target="_blank"
              rel="noopener noreferrer"
              style="color:#2D317F; font-weight:600; text-decoration:none;">
                  Contact Now
              </a>
              app.
            </p>
`,
      button: "Learn more",
      channels_logos: [
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/contact_now.svg",
          width: "80px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bee_basata.svg",
          width: "36px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/instapay.svg",
          width: "69px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/alahly_momkn.svg",
          width: "100px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/superpay.svg",
          width: "120px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/opay.svg",
          width: "116px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/fawry.svg",
          width: "118px",
        },
        {
          img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Homepage_channels_logos/damen.svg",
          width: "95px",
        },
      ],
    },
  },

  /** Home Interior تمويل التصميم والتشطيب*/

  investment: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/investement.png",
      color: "#5686A3",
      title1: "Contact Kol Yom saving and investment fund.",
      title2: "Your Everyday Investment Partner",
      description: `Contact Kol Yom offers a simple, secure, and rewarding way to grow your money daily. It is a secure and accessible investment tool that fits your financial aspirations. It leverages a diversified portfolio, ensuring steady, attractive returns while safeguarding your capital and liquidity.`,
    },
    outro: `Contact Kol Yom is more than just an investment, it's a commitment to your financial future. Join us and start experiencing the power of daily financial growth. Start your journey today!
    `,
    subOutro: " Don't wait, invest with Contact Kol Yom!",
  },

  featureSection: [
    {
      id: "1",
      delay: "0",
      img: "/home-services/finance.svg",
      title: "Financing",
      text: "Financing plans that suit all your needs",
    },
    {
      id: "2",
      delay: "150",
      img: "/home-services/insurance.svg",
      title: "Insurance",
      text: "One-stop shop for all your insurance needs",
    },
    {
      id: "3",
      delay: "300",
      img: "/home-services/invetment-new.svg",
      title: "Savings & Investment",
      text: "Your everyday investment partner",
    },
    {
      id: "4",
      delay: "450",
      img: "/home-services/payment.svg",
      title: "Payment Solutions",
      text: "Your payments made easy",
    },
  ],

  stepsFeature: [
    {
      id: "1",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/step-1-en.webp",
      title: "Instant approval",
      subTitle: "feature",
      text: "Apply for instant credit approval.",
    },
    {
      id: "2",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-2-en.png",
      title: "Credit limit increase",
      subTitle: "feature",
      text: "Apply for a credit limit increase.",
    },
    {
      id: "3",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-3-en.png",
      title: "Pay your bills",
      subTitle: "feature",
      text: "Pay your installments and bills.",
    },
    {
      id: "4",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-4-en.png",
      title: "Latest offers and promotions",
      subTitle: "feature",
      text: "Receive the latest offers and promotions.",
    },
    {
      id: "5",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-5-en.png",
      title: "Our merchants",
      subTitle: "feature",
      text: "Explore our merchants’ network.",
    },
  ],
  stepsFeature_business: [
    {
      id: "1",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-1-en.webp",
      title: "Medical Consultation",
      subTitle: "feature",
      text: "Immediate medical consultations, as well as benefiting from doctors’ instead in emergency cases through the application.",
    },
    {
      id: "2",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-2-en.webp",
      title: "Medication Reminder",
      subTitle: "feature",
      text: "Notifications for your medication's timings and doses.",
    },
    {
      id: "3",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-3-en.webp",
      title: "Wellness",
      subTitle: "feature",
      text: "Various health articles that help you adopt a healthy lifestyle and avoid wrong daily habits for a better healthy lifestyle.",
    },
    {
      id: "4",
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/insurance-step-4-en.webp",
      title: "Claims",
      subTitle: "feature",
      text: "Quick and easy submission of claims through the application and follow-up to provide a simple submission processs.",
    },
  ],
  map: {
    title: "Our Branches",
    subTitle:
      "We are close to you everywhere in Egypt through more than 60 branches throughout the republic",
    placeholderGovernate: "Governorate",
    placeholderBranch: "Find your nearest branch",
    noOption: "There are no governorates",
    noSearchResult: [
      "Sorry, there are no branches for your search at the moment.",
      "Try changing the branch and verify the accuracy of the entered data.",
    ],
    openNow: "Open now",
    closeNow: "Closed now",
    workingHours:
      "Open daily from 10:00 AM to 6:00 PM (except Friday and Saturday)",
    workingHours2:
      "Open daily from 10:00 AM to 8:00 PM (except Friday and Saturday)",
    workingHours3:
      "Open daily from 12:00 PM to 8:00 PM (except Friday and Saturday)",
    workingHours4:
      "Open daily from 10:00 AM to 10:00 PM (except Friday and Saturday)",
    workingHours5: "Open daily from 10:00 AM to 10:00 PM",
    KnowWay: "Know the way",
    Tab: ["Branches", "Map"],
    phone: "Phone number",
    openingHours: "Opening Hours",
    branchAddress: "Branch address ",
    list: [
      {
        name: "Installment plans for fuel-powered or electric cars — both new and used",
        url: "/products/auto",
      },
      {
        name: "Installment plans for fuel-power or electric motorcycles and scooters — both new and used",
        url: "/products/motorcycles",
      },
      { name: "Trucks Financing", url: "/products/trucks" },
      {
        name: "Furniture and Home Furnishing installment plans",
        url: "/products/home-furniture",
      },
      { name: "Home Interior Financing", url: "/products/home-interior" },
      {
        name: "Green Financing (solar panel systems and agricultural greenhouses)",
        url: "/products/green-finance",
      },
      { name: "Real estate (mortgage) financing", url: "/products/mortgage" },
      { name: "Hajj and Umrah financing", url: "/products/travel-and-tourism" },
      { name: "Club Membership installment plans", url: "/products/clubs" },
      {
        name: "Education Financing (including school fees, university tuition fees, postgraduate studies, PhDs, diplomas, and courses)",
        url: "/products/education",
      },
      { name: "Watercraft Financing", url: "/products/watercraft" },
    ],
    secondDesc:
      "In addition to a range of financial and insurance services tailored to every stage of your life journey",
    branch: {
      // "desc": "The {{branch}} offers all of Contact’s flexible financing solutions — from car and motorcycle loans to education, weddings, and solar energy systems. Whether you're furnishing your home or planning a big event, our team is ready to help you find the best installment plan."
      desc: "Contact Branch in {{branch}}– Comprehensive Financing Services Including:",
    },
  },

  contact_homes: {
    cover: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-homes.svg",
      color: "#2D9A8F",
      title1: "Homes",
      title2: "A new beginning for a perfect life",
      description: `Through the partnership between Contact and Coldwell Banker, you can take advantage of an endless world of benefits and offers. Providing you plenty of discounts and special prices`,
    },
    section_a: {
      title: "Program eligibility",
      body: `Coldwell Banker existing customer`,
    },
    section_b: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "Exclusive benefits for Contact clients from Coldwell Banker",
      body: [
        "1 Year Home Insurance",
        "Door Key Insurance",
        "Mobile, ipad & TV insurance",
        "50% discount on 2nd home insurance (North cost or Sokhna)",
      ],
    },
    section_c: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title:
        "Enjoy a world of unlimited benefits when you join Coldwell Banker Star club:",
      body: [
        "Free 3D home design sample on either the living room, bedroom, or one partition of the reception",
        "50% discount on 2D & 3D  modelling upon contractual agreement provided by RD design",
        "Up to 5 million EGP Contact Mortgage Loan",
        "Up to 500,000 EGP Contact Shopping loan",
        "Exclusive offers and discounts from Jotun, Ikea, and Carrier",
      ],
    },
    section_d: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/without-advance.webp",
      title: "",
      body: ["", "", "", ""],
    },
  },
  inistance: {
    Tittle: "Get Inistance credit limit aprovel",
    Tittle2:
      "Up to 50,000 EGP credit can be instanly yours! just follow thes steps",
    Start: "Get Started",
  },
  Login: {
    Next: "Next",
    Login: "Login",
    // PhoneTitle:
    //   " To log into your account, enter your phone number below, you will receive a one-time password (OTP) ",
    PhoneTitle: " To log into your account, enter your phone number ",
    // PhoneLabel: "+2 (010) 052-09153",
    PhoneLabel: "011xxxxxxxx ",
    PhoneError:
      "Phone number must be exactly 11 digits and  start with (010/011/012/015) directly",
    ErrorMessPhone: "There is no account for this number",
    ErrorLabel: "Error",
    PassTitle: "Please enter your password",
    PassLabel: "Password",
    ErrorMessPass:
      "The phone number or password you entered is incorrect. Please try again",
    ResetPassword: "Forgot password?",
    CheckUserExistence: "This user doesn’t exist",
    OTPTitle:
      "A one-time password has been sent to a phone number that ends with the number، please enter it below",
    UpdatePassword: "Update Password",
    ConfirmLabel: "Confirm Password",
    ErrorConFirmPass: "passwords do not match",
    SuccsessUpdatePAss: "Password Changed, Please Login To Access Your App",
    ResendOtp: "Resend OTP",
    OTPNotVerfy: "OTP is invalid ",
    VerificationToken: "An error occurred, please try again",
    resetError: "Please enter your phone number to reset the password",
  },
  user_installements: {
    RemaniningAmounts: {
      title: "The rest",
      amount: "20,000",
      currency: "EGP",
      paymentBtn: "Installment payment",
      totalAmountText: "Total Amount",
    },
    UpComingInstallement: {
      title: "Upcoming Installement",
      paymentBtn: "Pay All",
      UpComingDetails: [
        {
          id: "1",
          payTo: "Tradeline Store",
          payFor: "Macbook M1 Pro",
          totalAmountText: "Total Amount",
          totalAmount: "64,450",
          currency: "EGP",
          whatPaid: "2,686",
          total_number_installments: "24",
          number_paid_installments: "18",
          paymentBtn: "Installment payment",
        },
        {
          id: "2",
          payTo: "Tradeline Store",
          payFor: "Macbook M1 Pro",
          totalAmountText: "Total Amount",
          totalAmount: "64,450",
          currency: "EGP",
          whatPaid: "2,686",
          total_number_installments: "24",
          number_paid_installments: "18",
          paymentBtn: "Installment payment",
        },
        {
          id: "3",
          payTo: "Tradeline Store",
          payFor: "Macbook M1 Pro",
          totalAmountText: "Total Amount",
          totalAmount: "64,450",
          currency: "EGP",
          whatPaid: "2,686",
          total_number_installments: "24",
          number_paid_installments: "18",
          paymentBtn: "Installment payment",
        },
        {
          id: "4",
          payTo: "Tradeline Store",
          payFor: "Macbook M1 Pro",
          totalAmountText: "Total Amount",
          totalAmount: "64,450",
          currency: "EGP",
          whatPaid: "2,686",
          total_number_installments: "24",
          number_paid_installments: "18",
          paymentBtn: "Installment payment",
        },
      ],
    },
    PreviousDealing: {
      title: "Previous Dealing",
      nodataerr: "No data for now please try again later ......",
      PreDealingHead: {
        product: "Product",
        seller: "Seller",
        date: "Date",
        amount: "Amount",
        payMethod: "Payment Method",
      },
    },
  },
  customer_services: {
    title: "To speak to contact customer service",
    whatsappCall: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/whatsapp-2.png",
      title: "Talking on WhatsApp",
      subTitle: "To talk through the WhatsApp Quick Response Messaging Service",
      arrow:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/next-arrow.png",
    },
    hotLineCall: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/call.png",
      title1: "Talking Through ",
      title2: "Hotline",
      subTitle: "16177",
    },
    ourLocation: {
      img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/location.png",
      title: "Visit one of our branches",
      arrow:
        "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/next-arrow.png",
    },
  },
  profile: {
    title: "Profile",
    img: "../images/userProfile",
    imgBtn: "Change Image",
    email_title: "Email",
    extraInfo_title: "Additional Information",
    editBtn: "Edit",
  },
  userNav: {
    your_installement: "My Installments",
    call_center: "Reach Us",
    profile: "Profile",
    logout: "logout",
    welcome: "Welcome",
    loyaltyPoints: "Loyalty Points",
  },

  referral_program: {
    title: "Contact Referral Program",
    sub_title:
      "Nominate your friends and receive free points and exclusive discounts.",
    conditions: {
      title: "Contact referral Program terms and conditions",
      conditions_list: [
        "The candidate must be a contact registered customer.",
        "For existing Contact customers to obtain rewards points, new customers must make a contract for one of Contact products.",
        "For Contact Shopping and Contact Finishing only, nominated customers must complete at least one purchase transaction after credit approval and contracting so that existing customers can get reward points automatically.",
        "Existing Contact customers can filter their knowledge through the website, the Contact mobile application, the forms inside the branches, customer service centers or through the official social media platforms of Contact.",
        "A maximum limit for existing Contact clients is to nominate 10 new clients per month.",
      ],
    },
    program_benefits: "Contact Benefits",
    benefites_list: [
      "Existing Contact customers are rewarded by obtaining rewards points, where the number of points is determined according to the different Contact products.",
      "Rewards points can be used for purchases from Contact Rewards Program partners.",
      "The points can be used to pay Contact installments or administrative expenses.",
    ],
  },

  application: {
    job_title: "Software Developer",
    job_desc:
      "We are looking for a distinguished programmer to join our team in developing and maintaining computer programs. He must have previous experience in developing programs and dealing with different programming languages. The programmer will work in a flexible work environment and must have the ability to withstand work pressure and work individually and in a team. ",
    to_apply: "If you would like to join us, please fill out the form.",
    resume_upload: {
      title: "Click or drag the file to this area to upload",
      sub_title:
        " Support for a single or bulk upload. Strictly prohibited from uploading company data or other banned files.",
    },
  },
  news: {
    title: "Our News",
    subtitle: "News that matters to you about Contact",
    minutes: " minutes reading",
    read_more: "Read more",
    share: "Share",
  },
  errorPage: {
    title: "Page not found",
    Home: "Back to main Page",
  },
  internetConnectionPage: {
    title: "Sorry!!",
    subTitle: "No internet connection. Check your connection and try again",
    Home: "Reload",
  },
  blogs: {
    title: "Blogs",
    latestBlog: "Latest Blogs",
    intro: "Introduction",
    table_content: "Table of Content",
    other_blogs: "Other blogs written by the author",
    similar: "Similar blogs",
    features: "Latest articles",
    about_author: "About the Author",

    authors: [
      {
        id: "rahaf-mohamed",
        name: "Rahaf Mohamed",
        bio: "A digital marketing specialist with a passion for crafting content that informs, engages, and delivers results. With a strong background in SEO, content strategy, and user experience, she creates blog articles that simplify complex topics and provide real value to readers. Her work is focused on helping audiences discover practical insights.",
        img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/rahaf.jpg",
        sharedId: "1",
      },
    ],
  },

  Campaign: {
    Title1: `Thank you for reaching out with Contact!`,
    Title2: `Please fill the form and one of our representatives will contact you shortly`,
    catalogueTitle: "All your dreams and more with just one click.",
    catalogueSubTitle:
      "Fill in your details and we’ll reach out when it’s convenient for you.",
    financing_title: "Buy your BMW now with the lowest interest rate in Egypt",
    financing_pg: (
      <>
        <p>
          0% Admin Fees | 4.4% Interest Rate| 3 Years Full Service| 5 years
          Warranty
        </p>
        <p>Apply Now to get your financial loan</p>
      </>
    ),
  },

  ///////====================feedback=====================
  feedback: {
    sections: [
      {
        id: 1,
        type: "satisfactionRating",
        question: "How easy was it to use our website?",
        defaultOptions: [
          {
            id: 1,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/angryEmoj.svg",
            text: "Very Bad",
          },
          {
            id: 2,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/sadEmoj.svg",
            text: "Bad",
          },
          {
            id: 3,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/mehEmoj.svg",
            text: "Neutral",
          },
          {
            id: 4,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/happy.svg",
            text: "Good",
          },
          {
            id: 5,
            src: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/feedback/goodEmoj.svg",
            text: "Very good",
          },
        ],
      },
      {
        id: 2,
        type: "informationHelpful",
        question: "Did you find what you were looking for?",
        options: [
          { id: 1, text: "Yes" },
          { id: 2, text: "No" },
        ],
      },
    ],
    slider: {
      question: "Would you recommend others to work with us?",
      labels: {
        low: "Not Likely",
        mid: "Neutral",
        high: "Extremely Likely",
      },
    },
    buttonTitle: "Your Feedback",
    textareaPlaceholder:
      "Your suggestions for improving the website’s performance..",
    buttonText: "Submit",
    successFeedback: "You Feedback has been sent successfully.",
    failFeedback:
      "An Error occurred. Please try submitting your Feedback again.",
  },

  // ***********
  navbar_investment: "Investment",
  investment_dropdown: [
    {
      url: "/investment/cash-management",
      color: colors.ratty,
      img: "https://contact-eg.s3.us-east-2.amazonaws.com/general/cash-mangement.webp",
      title: "Cash Management",
    },
    {
      url: "/investment/income-trading",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/income-trading.png",
      title: "Income Trading",
    },
    {
      url: "/investment/investment-fund",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/investment-fund.png",
      title: "Investment Fund",
    },
  ],
  navbar_partnership: "Become a Partner",
  partner_dropdown: [
    // {
    //   url: "/partnership/contact-now-merchant",
    //   color: colors.ratty,
    //   img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
    //   title: "ContactNow Merchant",
    // },
    {
      url: "/partnership/leasing-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "Leasing Partners ",
    },
    {
      url: "/partnership/factoring-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "Factoring Partners",
    },
    {
      url: "/partnership/business-partners",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "Business Partners",
    },
  ],

  business: {
    logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact.png",
    cover_title: "Your Financial Partner",
    cover_body:
      "Support your business with leasing, factoring and mortgage portfolio acquisition, alongside insurance and investment services tailored to your next step",
    btn1: "Request service",
    btn2: "Join Us",
    sponsor_title: "Our Partners",
    sponsors: [
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/1.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/2.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/3.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/4.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/5.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/6.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/7.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/8.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/9.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/10.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/11.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/12-en.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/13-en.png", // fawry
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/15.png",
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/16-en.png", // basata
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/17-en.png", // jumia
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/raya.svg", //raya
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/orange.svg", //Orange
      "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/vodafone.svg", //Vodafone
    ],
    plans_title: "Quis autem vel eum iure reprehenderit qui",
    plans_subtitle: "Tagline",
    plans_description:
      "diam laoreet consectetur libero, elit sollicitudin. felis, ac ipsum In nisi id ullamcorper felis, efficitur. faucibus elit. orci in Ut urna. massa Cras orci",
    btn11: "More",
    btn22: "Follow",
    card_title: "Quis autem vel eum iure reprehenderit qui",
    card_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros.",
    testimonial_title: "Success stories from our partners",
    testimonial_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    reviews_business: [
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/hossam-avatar.jpg",
        name: "Mr. Hossam Ezz",
        role: "Chief Commercial Officer-Enterprise, Fawry",
        rating:
          "We are very pleased with our partnership with Contact, which has extended over the past years and has been crowned with many successes, this step represents a consolidation of cooperation between the two sides with the aim of enhancing the values of financial inclusion and advancing the wheel of digital transformation",
      },
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/adham-avatar.jpg",
        name: "Mr. Adham Hosny",
        role: "Chief Product & Strategy Officer, Carzami",
        rating:
          "Our remarkable partner, “Contact”, has played a significant role in our success by providing prompt approvals and innovative collaborations. We are privileged to have them as our partners, and we take immense pride in our association with them.",
      },
      {
        avatar:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mahmoud.jpg",
        name: "Mr. Mahmoud El Said",
        role: "Title: Co-Founder & CEO, Wasla Browser",
        rating:
          "We believe our partnership with “Contact” allows us to continuously expand our offering and introduce new ways to help consumers save money, pay securely, and borrow flexibly",
      },
    ],
    news_title: "Our News",
    news_description: "Main News",
    btn111: "View all",
    accordion: [
      {
        title:
          "How does Contact help businesses overcome financial challenges?",
        description:
          "We empower businesses by providing financing solutions for essential assets and immediate cash flow, we provide you with a wide range of key financial solutions through our Leasing programs, Factoring services, LaaS, and more!",
      },
      {
        title:
          "How does Contact help Individuals to secure their financial & health future, and help to secure corporate employees’ health and future?",
        description:
          "We empower both individuals and businesses to safeguard their health and financial future by offering diversified solutions, including Individual and Group Medical Insurance Plans, Life Insurance Plans, Investment Plans, Retirement Plans, Protection and Savings Coverage & more!",
      },
      {
        title: "How to apply for our products & services?",
        description:
          "You can submit your request through all our channels: Our nationwide Branches, Website, Mobile App, WhatsApp Chatbot or call center 16177.",
      },
      {
        title: "Why choose a financing company over a bank financing?",
        description:
          "Financing companies offer faster procedures and flexible financing terms along with faster approvals!",
      },
    ],
    faqs: "FAQs",
    faqs_description: "Empowering Your Financial Journey!",
  },
  exclusiveOffersList: [
    {
      optionId: "2",
      title: "Dongfeng Car",
      value: "DongfengCar",
    },
    {
      optionId: "3",
      title: "Voyah Car",
      value: "VoyahCar",
    },
    {
      optionId: "4",
      title: "Smart Car",
      value: "SmartCar",
    },
    {
      optionId: "5",
      title: "Volvo Car",
      value: "VolvoCar",
    },
    {
      optionId: "6",
      title: "Golf Car Offer",
      value: "GolfCarOffer",
    },
    {
      optionId: "7",
      title: "Jet Ski Offer",
      value: "JetSkiOffer",
    },
    {
      optionId: "8",
      title: "Jet Car Offer",
      value: "JetCarOffer",
    },
    {
      optionId: "9",
      title: "Speed Boat Offer",
      value: "SpeedBoatOffer",
    },
    {
      optionId: "10",
      title: "Home Furniture",
      value: "HomeFurniture",
    },
  ],
  business_profile_list: [
    {
      optionId: "1",
      title: "Auto",
      value: "Auto",
    },
    {
      optionId: "1",
      title: "Motorcycles",
      value: "Motorcycles",
    },
    {
      optionId: "1",
      title: "Trucks",
      value: "Trucks",
    },
    {
      optionId: "1",
      title: "Watercraft",
      value: "Watercrafts",
    },
    {
      optionId: "2",
      title: "Mortgage",
      value: "Mortgage",
    },
    {
      optionId: "2",
      title: "Home Interior",
      value: "Homes",
    },
    {
      optionId: "2",
      title: "Home Furniture",
      value: "HomeFurniture",
    },
    {
      optionId: "5",
      title: "Education",
      value: "Education",
    },
    {
      optionId: "5",
      title: "Clubs",
      value: "Clubs",
    },
    {
      optionId: "5",
      title: "Shopping",
      value: "shopping",
    },
    {
      optionId: "2",
      title: "Maintenance",
      value: "Maintenance",
    },
    {
      optionId: "3",
      title: "Insurance Brokerage",
      value: "Brokerage",
    },
    {
      optionId: "3",
      title: "Sarwa Life",
      value: "Life",
    },
    {
      optionId: "3",
      title: "Sarwa Insurance",
      value: "Insurance",
    },
    {
      optionId: "4",
      title: "Nursery",
      value: "Education",
    },
    {
      optionId: "4",
      title: "Schools",
      value: "Education",
    },
    {
      optionId: "4",
      title: "Universities",
      value: "Education",
    },
    {
      optionId: "4",
      title: "Post Grad",
      value: "Education",
    },
    {
      optionId: "6",
      title: "Green Finance",
      value: "GreenFinance",
    },
    {
      optionId: "7",
      title: "Manasik",
      value: "Manasik",
    },
    {
      title: "Factoring",
      value: "Factoring",
    },
    {
      title: "Leasing",
      value: "Leasing",
    },
  ],
  //* sustainability
  sus_t1: "Sustainability",
  sus_b1: `At Contact, sustainability is one of our main concerns; we allocate all the available resources to environmental protection, sustainable development, and social solidarity, such as low-income support programs, women empowerment, and enabling people with disabilities. The urge to support sustainability comes from our responsibility towards our community, as most firms and financial corporations prioritize short-term gains over long-term sustainability.
We focus on integrating sustainability in our decision-making processes through various ways such as green finance, green bonds, sustainable investment practices, corporate social responsibility, and following governmental policies that stimulate sustainable development investments, economic efficiency, and environmental protection.`,
  sus_t2: "SDG Alignment",
  sus_st2: "Our 2023-2025 action plan and alignment with the following SDGs:",
  sus_b2: [
    "Good Health and Well-Being",
    "Quality Education",
    "Decent Work and Economic Growth",
    "Reduced Inequalities",
    "Climate Action",
    "Partnerships for the Goals",
  ],
  sus_img2:
    "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sus-logo.webp",
  sus_reports: [
    {
      title: "View our Sustainability Report for the year 2026",
      link: "https://contact-app-prod.s3.us-east-2.amazonaws.com/IR_investors/TCFD-CFH-2026.pdf",
    },
    {
      title: "View our Sustainability Report for the year 2024",
      link: "/contact-sustainability-report2023.pdf",
    },
  ],

  Readmore: "Read more",
  pages_main_tags: {
    home: {
      title: "Contact Financial Holding | Best Financing Company in Egypt",
      meta_desc:
        "Get financing solutions with the best financing company in Egypt. Apply for car finance, education, travel, mortgage, and maintenance financing with Contact.",
      h1: "Welcome to Contact",
      h2: "Innovative Financial Solutions for Every Need",
    },
    about: {
      title: "About Contact | Know All About Contact's Story & Vision",
      meta_desc:
        "Learn about Contact, Egypt’s leading provider of finance solutions, offering auto credit, insurance, consumer & corporate finance, and debt market services.",
    },
    products: {
      insurance: {
        title: "Insurance Brokerage by Contact | Best Insurance Services",
        meta_desc:
          "Enjoy the best insurance plans in Egypt with Contact. Get comprehensive protection for you and your family, including life insurance, and health insurance.",
      },
    },
    epyament: {
      title: "Contact Pay | Electronic Payments & Bill Payment Services",
      meta_desc:
        "Pay all your bills with Contact Pay, a secure E-Payment solution in Egypt. Easily settle electricity, gas, water bills, school and university fees, and more",
      h1: "E-Payment Solutions",
      h2: "Convenient & Secure Payment Options",
    },
    investment: {
      title: "Debt Capital Markets & Portfolio Management with Contact",
      meta_desc:
        "Contact is one of your trusted Debt Capital Market partner in Egypt, offering securitization, sukuk issuance, and underwriting for your financial goals.",
      h1: "",
      h2: "",
    },
    sarwaInsurance: {
      title: "Sarwa Insurance: Top Insurance Company within Contact Group",
      meta_desc:
        "Protect what matters to you with Sarwa Insurance. Comprehensive plans for individuals and businesses in Egypt, backed by trusted Contact Financial Group.",
      h1: "Sarwa Insurance",
      h2: "Comprehensive Coverage for Peace of Mind",
    },
    blogs: {
      title: "Ultimate Guide to Financing & Installments | Contact Blog",
      meta_desc:
        "Stay updated with Contact’s latest financial tips and market insights, and learn how to make smarter decisions with financing solutions and helpful articles.",
      h1: "Contact Blog",
      h2: "Latest Financial Insights and Tips",
    },
    contactUs: {
      title: "Contact Us | Reach Contact's Customer Financing Support",
      meta_desc:
        "Call Contact Customer Service at 16177 for financing details and services. Our team is ready to answer your questions quickly, clearly, and easily now.",
      h1: "Get in Touch with Us",
      h2: "We're Here to Assist You",
    },
    login: {
      title: "",
      meta_desc: "",
      h2: "",
    },
    sustainability: {
      title: "Sustainability at Contact | Our Strategy for a Better Future",
      meta_desc:
        "Discover how Contact supports sustainability through initiatives and social responsibility efforts that create a better future for people and communities.",
      h1: "Sustainability at Contact",
      h2: "Our Commitment to a Greener Tomorrow",
    },
    sarwaLife: {
      title: "Sarwa Life Insurance: Part of Contact Financial Holding",
      meta_desc:
        "Sarwa life insurance protects your family’s future with comprehensive coverage and peace of mind. Trusted services from Contact Financial Group today.",
      h1: "Sarwa Life Insurance",
      h2: "Life Insurance That Cares for Your Loved Ones",
    },
    sarwaCapital: {
      title: "Sarwa Capital - Egypt's Leading Debt Capital Market Firm",
      meta_desc:
        "Sarwa Capital, a subsidiary of Contact Financial Holding, offers expert asset management and investment solutions.",
      h2: "",
    },
    referralProgram: {
      title: "Contact Referral Program - Refer Friends & Earn Rewards",
      meta_desc:
        "Take advantage of Contact’s referral program and earn rewards easily. Refer friends and enjoy exclusive benefits, offers, and great experiences today.",
      h1: "Referral Program",
      h2: "Share the Benefits, Earn Rewards",
    },
    rewards: {
      title: "Rewards Program - Contact | Enjoy Exclusive Benefits",
      meta_desc:
        "Discover Contact's Rewards Program and enjoy exclusive benefits and discounts. Loyalty pays off with Contact's exclusive options!",
      h1: "Rewards Program",
      h2: "Exclusive Benefits for Loyal Customers",
    },
    ourBranches: {
      title: "Contact Branches | Locations of Financing Company in Egypt",
      meta_desc:
        "Find the nearest Contact branch in Egypt. Explore all our branch locations and installment services with fast procedures and a seamless customer experience.",
      h1: "Our Branches",
      h2: "Find a Contact Branch Near You",
    },
    ourBrands: {
      title: "Our Brands | Discover Contact Financial Holding Portfolio",
      meta_desc:
        "Explore Contact's brands, including Contact, Sarwa Life, Insurance, Capital, and Contact Cars, offering integrated financial and insurance solutions in Egypt.",
      h1: "",
    },
    branchDetails: {
      default: {
        title: "Contact {{branch}}: Your Local Financing Center",
        meta_desc:
          "Visit the Contact {{branch}} branch for all your financing needs. Find our full address, opening hours, and a wide range of installment plans. Call us at 16177",
      },

      "abu-kibir": {
        title: "Contact Abu Kibir - Address & Phone Number for Abu Kibir",
        meta_desc:
          "Contact Abu Kibir branch in Sharqia offers fast financing and installment services. Check the address, phone number, and working hours before your visit.",
      },

      "menofia-shibin-elkom": {
        title: "Contact Shibin Elkom | Shibin Elkom Menofia Branch",
        meta_desc:
          "Looking for Contact in Shibin Elkom? Find branch location details, contact number, opening hours, and explore available financing and installment services.",
      },

      "alexandria-ring-road": {
        title: "Contact Alexandria Ring Road | All the Branch Details",
        meta_desc:
          "Contact Alexandria Ring Road branch offers fast and convenient financing services. Check the address, phone number, and working hours, Call us at 16177.",
      },

      "alexandria-el-agamy": {
        title: "Contact El-Agamy Branch | Alexandria El-Agamy Branch Info",
        meta_desc:
          "Contact Alexandria El-Agamy branch provides flexible financing and installment solutions. Check the branch address and working hours or call 16177 for details.",
      },

      "alexandria-corniche": {
        title: "Contact Alexandria Corniche Branch | Financial Solutions",
        meta_desc:
          "Contact Alexandria Corniche branch offers financing, smart savings, and investment solutions backed by over 20 years of experience and flexible payments.",
      },
      "6th-october": {
        title: "Contact 6 October Branch | Flexible Financing & Installments",
        meta_desc:
          "Contact 6 October branch offers installment plans starting from 10% down payment and financing up to EGP 10M. Insurance & investment solutions. Call 16177.",
      },
      "alexandria-roshdy": {
        title: "Contact Roushdy Alexandria | Smart Financial Solutions",
        meta_desc:
          "At Contact Roushdy Alexandria, enjoy flexible financing, easy installment plans, plus insurance and investment solutions tailored to your needs. Call 16177.",
      },
      aswan: {
        title: "Aswan Branch | Ask about financing plans at Aswan branch",
        meta_desc:
          "Contact Aswan branch provides complete financial solutions, from flexible installments to powerful financing options, plus insurance and savings plans.",
      },
      asyut: {
        title: "ِِAsyut Contact | Financing and installment options in Asyut",
        meta_desc:
          "Contact Asyut branch offers tailored installment plans and financing up to EGP 10M, along with insurance & investment solutions. Visit the branch or Call 16177.",
      },
      benha: {
        title: "Contact Banha | Installments & Financial Services in Banha",
        meta_desc:
          "Contact Banha branch offers easy installment plans and tailored financing solutions, plus insurance, and investment services. Visit us for any inquiries.",
      },
      "beni-mazar": {
        title: "Beni Mazar | Flexible Financing & Installment Solutions",
        meta_desc:
          "Visit Contact Beni Mazar branch and explore financing and installment options with flexible plans and easy terms tailored to your needs today now. Get started!",
      },
      "beni-suef": {
        title: "Contact Beni Suef | Financing & Installment Program Now",
        meta_desc:
          "Explore financing solutions at Contact Beni Suef branch with flexible plans and multiple options designed to match your needs and budget today right now.",
      },
      "city-stars-mall": {
        title: "Contact Citystars | Easy and Fast Financing Options App",
        meta_desc:
          "Discover financing solutions and flexible installment plans at Contact Citystars branch. Call 16177 for more details and support today anytime now. Learn more",
      },
      damanhour: {
        title: "Contact Damanhur Branch | Flexible Financing Option Now",
        meta_desc:
          "Contact Damanhur branch offers flexible financing and installment solutions tailored to your needs. Call 16177 for more information today anytime now.",
      },
      damietta: {
        title: "Contact Damietta Branch | Flexible Financing Plans",
        meta_desc:
          "Discover financing and installment services at Contact Damietta branch with flexible solutions designed to give you more choices today and more. Contact with us",
      },
      dokki: {
        title: "Contact Dokki Branch | Easy & Flexible Financing Solutions",
        meta_desc:
          "Contact Dokki Branch offers flexible financial solutions, from financing and installment plans to easy repayment options, with expert guidance tailored for you.",
      },
      "downtown-5th-settlement": {
        title: "Contact Downtown Branch | Financing Up to EGP 10M",
        meta_desc:
          "Looking for flexible financing? Contact Downtown New Cairo offers installment plans with down payments starting at 10%, plus insurance solutions for your future",
      },
      "el-gouna": {
        title: "Contact El Gouna Branch | Finance, Insurance & Savings",
        meta_desc:
          "At Contact El Gouna Branch, enjoy integrated financial services including financing, installments, and smart solutions tailored to your lifestyle and goals.",
      },
      "el-abaseya": {
        title: "Contact Abbassia Branch | Flexible Financial Services",
        meta_desc:
          "Contact Abbassia Branch offers integrated financing and installment solutions with flexible repayment plans and expert support to help you choose best option.",
      },
      "el-bahr-el-azam": {
        title: "Contact Bahr El Aazam | Flexible Financing & Installments",
        meta_desc:
          "Visit Contact Bahr El Aazam Branch for flexible financing and installment plans with 10% down payment and financing up to EGP 10 million. Call 16177 today.",
      },
      "el-mahalla-el-kubra": {
        title: "Contact El Mahalla Branch | Flexible Financing Solutions",
        meta_desc:
          "Visit Contact El Mahalla Branch and explore flexible financing and installment plans tailored to your needs, with expert support every step of the way.",
      },
      faisal: {
        title: "Contact Faisal Branch | Financing & Easy Installments",
        meta_desc:
          "Discover flexible financing and installment plans at Contact Faisal Branch, plus insurance, savings, and investment solutions designed to fit your budget.",
      },
      faiyum: {
        title: "Contact Faiyum Branch | Flexible Financing Solutions",
        meta_desc:
          "Visit Contact Faiyum Branch for flexible financing and installment solutions, along with a full range of financial services to help you achieve your goals.",
      },
      giza: {
        title: "Contact Giza Branch | Financing & Financial Solutions",
        meta_desc:
          "Contact Giza Branch offers flexible financing and installment plans, plus insurance, savings, and investment services tailored to your financial needs.",
      },
      "masr-al-gadida": {
        title: "Contact Masr Al Gadida Branch | Easy Financing Solutions",
        meta_desc:
          "Visit Contact Masr Al Gadida Branch to explore flexible financing and installment options, with expert guidance and financial solutions for every stage of life.",
      },
      helwan: {
        title: "Contact Helwan Branch - Financing Up to EGP 10M, 10% Down",
        meta_desc:
          "Contact Helwan branch offers financing up to EGP 10M over 5 years, 10% down payment, insurance, savings & investment. Easy apply, fast approval. Call 16177",
      },
      hurghada: {
        title: "Contact Hurghada Branch - Insurance To Protect Your Family",
        meta_desc:
          "Contact Hurghada branch offers comprehensive insurance plans to protect you and your loved ones, plus flexible financing from 10% down. Apply easily. Call 16177",
      },
      ismailia: {
        title: "Contact Ismailia Branch - Start Smart Saving Plans Today",
        meta_desc:
          "Contact Ismailia branch helps you start smart savings plans to reach your goals, plus flexible financing from 10% down. Apply easily, fast approval. Call 16177",
      },
      "kafr-el-sheikh": {
        title: "Contact Kafr El Sheikh - Investment Options For Your Future",
        meta_desc:
          "Contact Kafr El Sheikh branch opens investment opportunities to grow your money, plus flexible financing from 10% down, up to 5 yrs. Apply easily. Call 16177",
      },
      "kafr-el-dawar": {
        title: "Contact Kafr El Dawar - Flexible Payment Methods For You",
        meta_desc:
          "Contact Kafr El Dawar branch offers flexible payment methods for your lifestyle and budget, plus financing up to EGP 10M from 10% down. Apply easily. Call 16177",
      },
    },
    productsPage: {
      title: "All Products - Contact | Explore Our Full Range of Services",
      meta_desc:
        "Discover the full range of products and services offered by Contact. The best financing services and insurance plans in Egypt, find what you need.",
      h1: "All Products",
      h2: "Explore Our Comprehensive Range of Services",
    },
    companies: {
      title: "Corporate Financing with Contact: Business Finance Solutions",
      meta_desc:
        "Discover business financing solutions from Contact. Our services include corporate finance, financial leasing, and factoring to support your company’s growth.",
      h1: "Corporate Solutions",
      h2: "Customized Solutions for Your Business",
    },
    partnership: {
      contactNowMerchant: {
        title: "ContactNow for Merchants | Financing Solutions for Retailers",
        meta_desc:
          "Join Contact Now partner network and grow your business by offering fast, flexible financing options that boost sales, strengthen trust, and customer loyalty.",
        h1: "Contact Now Merchant Partnership",
        h2: "Grow Your Business with Contact Now",
      },
      OtherEntities: {
        title: "Supply Products & Services with Installment Plans | Contact",
        meta_desc:
          "Contact collaborates with diverse partners across multiple sectors to deliver advanced financial services and flexible financing solutions with confidence.",
      },
      Vehicles: {
        title: "Cars & Transport Equipment Suppliers | Join Contact Network",
        meta_desc:
          "Through Contact’s strong partnerships with car suppliers and transport providers, access integrated financing solutions that make vehicle ownership easier.",
        h2: "",
      },
      Medical: {
        title: "Medical Equipment Financing Solutions | Contact Suppliers",
        meta_desc:
          "Contact partners with top medical suppliers to provide financing solutions that help individuals and businesses access essential medical supplies with ease.",
        h2: "",
      },
    },
    media: {
      title: "Media and News | Contact Financial Latest Updates",
      meta_desc:
        "Stay updated with the latest news, press releases, and media coverage from Contact Financial Holding, Egypt’s leading finance solutions provider.",
    },
    careers: {
      title: "Careers at Contact Financial | Finance Company Jobs in Egypt",
      meta_desc:
        "Explore career opportunities at Contact and join a team of 2,500+ employees in a workplace that supports growth and long-term career development opportunities.",
      h1: "Careers",
      h2: "If you would like to join us.",
    },

    contactUae: {
      title: "Financing Services in UAE | Contact Us at Contact Financial",
      meta_desc:
        "Contact UAE offers flexible financing solutions tailored to personal and business needs. Call +971547004400 and achieve your goals faster with ease today now.",
      h1: "Contact – UAE Office",
      h2: "Buy in Egypt, Pay from UAE",
      h3: [
        "Financing Services for Expats and Businesses",
        "Get in Touch with Us Today",
      ],
      scripts: [
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "Contact",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Damac XL Tower Business Bay – Office 905",
            addressLocality: "Dubai",
            addressCountry: "UAE",
          },
          telephone: "+971 54 700 4400",
          email: "info@contact.eg",
          url: "https://contact.eg/contact-uae",
        },
      ],
    },
    productsBusiness: {
      factoring: {
        title: "Factoring Services by Contact | Invoice Financing in Egypt",
        meta_desc:
          "وفر فلوس وسيولة لاحتياجاتك واحتياجات مشروعك واستفيد من خدمة التخصيم من كونتكت، الحل اللي بيـسـمـحلك تستبدل فواتير مبيعاتك وتاخد فلوسها فـوراً بدون انتظار",
        h1: "",
      },
      leasing: {
        title: "Financial Leasing in Egypt | Contact Financing Solutions",
        meta_desc:
          "كونتكت هي شركة رائدة في تقديم خدمات التأجير التمويلي لمختلف القطاعات في مصر. خطط سداد متنوعة مصممة لتناسب احتياجاتك.",
        h1: "",
        h2: "",
      },
    },
    whyContact: {
      title: "Why Choose Contact: Financing & Insurance Solutions in Egypt",
      meta_desc:
        "Discover why Contact is your first choice for financing and insurance. We offer fast, easy services for all life stages, available anytime, anywhere you are.",
      h1: "Why Choose Contact for Your Financing and Insurance Needs?",
      h2: "Our Positioning Pillars",
      h3: [
        "Expertise & Trust",
        "One-Stop Shop for Financing & Insurance",
        "Digital Convenience & Accessibility",
        "Empowering Your Ambition",
      ],
      navigation_bar: {
        sections: [
          { id: 1, title: "Expertise and Trust", href: "Expertise&Trust" },
          {
            id: 2,
            title: "One Stop Shop",
            href: "One-Stop-Shop",
          },
          {
            id: 3,
            title: "Digital Convenience",
            href: "Financing_Insurance_Products",
          },

          { id: 4, title: "Empowers Your Ambition!", href: "Ambition" },
        ],
        contact_us: "Contact Us",
      },
      header: {
        title: (
          <>
            We Provide{" "}
            <strong style={{ color: colors.orange }}>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  color: colors.orange,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `3px dashed ${colors.orange}`,
                    borderImageSource: `repeating-linear-gradient(55deg, ${colors.orange} 5px 20px, transparent 10px 30px)`,
                    borderImageSlice: 2,
                    borderRadius: "8px",
                    transform: "skew( 0deg, -1deg )",
                  },
                }}
              >
                INNOVATIVE FINANCING
              </Box>{" "}
              & Insurance
            </strong>{" "}
            Solutions
          </>
        ),
        btn: "Let's Explore",
        video:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/why-contact-andriod-en.mp4",
      },
      expertise: {
        title: "Expertise & Trust:",
        text: "For over 20  years, Contact has been Egypt’s leading consumer finance company, providing tailored financial solutions designed to support you at every stage of life. Whether you need financing for life’s big moments, comprehensive insurance coverage, or seamless electronic payment services, we deliver fast, secure, and flexible options. Backed by decades of expertise in finance and insurance, we are committed to empowering your financial journey with reliability and innovation.",
        btn: "Discover our products",
        statistic: [
          { id: "1", sufTheous: " K", text: "Customers served", count: 425000 },
          { id: "2", sufTheous: " ", text: "Branches nationwide", count: 60 },
          {
            id: "3",
            sufTheous: " K",
            text: "Largest Merchants’ Network in Egypt",
            count: 18000,
          },
        ],
      },
      services: {
        mainTitle: "One-Stop Shop",
        title: (
          <p>
            <strong>Contact</strong> offers{" "}
            <strong>financing, insurance, and online payments services </strong>{" "}
            in one place, ensuring a seamless and hassle-free experience for
            customers.
          </p>
        ),
        ourServices: [
          {
            id: 1,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-services-ar.png",
            text: "Contact",
            color: colors.blue,
            link: "/",
          },
          {
            id: 2,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-life.png",
            text: "Sarwa Life",
            color: colors.lemon_green,
            link: "/sarwa-life",
          },
          {
            id: 3,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/sarwa-insurance.png",
            text: "Sarwa Insurance",
            color: colors.blue,
            link: "/sarwa-insurance",
          },
          {
            id: 4,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-insurance-en.png",
            text: " Contact Insurance Brokerage",
            color: colors.blue,
            link: "/products/insurance",
          },
          {
            id: 5,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/payment.png",
            text: "Bill Payments",
            color: colors.orange,
            link: "/e-payment",
          },
        ],
      },
      financingInsuranceProducts: {
        title: (
          <p>
            <strong>
              Digital Convenience & Accessibility at Your Fingertip
            </strong>
          </p>
        ),
        products: [
          {
            id: 1,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-1.png",
            title: "Our Website Contact.eg",
            text: "We offer you a different and advanced experience of financial and insurance solutions and services for individuals and companies, whether from your mobile, laptop, or tablet, so that we are always your first choice for financing and insurance.",
            link: "/",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "Through our website, you can find all the information you need about our products and financing services",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/installment.svg",
                text: "You can calculate your installments quickly and easily",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "You can apply for financing and insurance requests from the comfort of your location",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "You can track your installments, products, and points through your personal account",
              },
            ],
          },
          {
            id: 2,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-2.png",
            title: "Contact Mobile Application",
            text: "“Contact Now” mobile application allows you to access all the information you need about our financing and insurance products, apply for financing requests from your location, and benefit from exclusive installment offers customized just for you.",
            link: "https://onelink.to/frpjkg",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "Instant approval for the credit limit",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/credit-limits.svg",
                text: "Request a credit limit increase",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/bills.svg",
                text: "Pay your bills and installments",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/merchants.svg",
                text: "Explore our merchants’ network",
              },
            ],
          },
          {
            id: 3,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-3.png",
            title: "Contact Insurance Brokerage Mobile Application",
            text: "Contact Insurance Brokerage mobile app is your go-to solution for all insurance needs. It simplifies choosing the right insurance plans—whether personal, family, or commercial—while offering a range of services to enhance your daily life and overall well-being.",
            link: "https://qr.me-qr.com/4UGQWwew",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "Submit insurance claims",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/medical-consultations.svg",
                text: "Get Medical consultations",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/physical-health.svg",
                text: "Tips that matter to your physical health and Medication reminder",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "Request insurance services for yourself, your family, or your business",
              },
            ],
          },
          {
            id: 4,
            img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/mockup-block-4.png",
            title: "Contact WhatsApp Chatbot",
            text: "Introducing our WhatsApp Chatbot – your smart assistant for all your consumer finance needs! Whether you're seeking information, exploring options, or looking for quick support with your financial & insurance services, our chatbot is here to help, 24/7. It's fast, easy, and available at your fingertips – simply send us a message on WhatsApp to get started!",
            link: "https://wa.me/20216177",
            services: [
              {
                id: 1,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/online-services.svg",
                text: "Quick replies",
              },
              {
                id: 2,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/availability.svg",
                text: "24/7 availability",
              },
              {
                id: 3,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/repayment-periods.svg",
                text: "You can track your installments, products, and points",
              },
              {
                id: 4,
                img: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/save-money.svg",
                text: "You can apply for financing and insurance services from the comfort of your location",
              },
            ],
          },
        ],
      },
      ambition: {
        bgImage:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contatct-ambition.png",
        logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-logo-ar.png",
        title: "We Empower Your Ambition!",
        description:
          "Contact understands your ambitions and helps you achieve your dreams, bringing you closer to provide innovative solutions that suit your needs, not just financing... but a part of your daily life!",
        btn: "Contact us",
      },
    },
    paymentChannels: {
      title: "Payment Channels | Pay Your Contact Installments Easily",
      description:
        " Pay your Contact installments quickly through our branches or payment channels, including InstaPay, Bee, and more. Multiple payment methods to fit your needs.",
      scripts: [
        {
          "@context": "https://schema.org",
          "@type": "PaymentService",
          url: "https://contact.eg/payment-channels/",
          name: "Payment Channels | Pay Your Contact Installments Easily",
          description:
            "Pay your Contact installments quickly through our branches or payment channels, including InstaPay, Bee, and more. Multiple payment methods to fit your needs.",
          serviceType: "Online Payment Channels",
          provider: {
            "@type": "Organization",
            name: "Contact",
            url: "https://contact.eg/en",
            logo: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/logo-en.webp",
            sameAs: [
              "https://www.facebook.com/ContactEg",
              "https://www.instagram.com/contact.eg/",
              "https://www.linkedin.com/company/contact-eg/",
            ],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "16177",
              contactType: "customer support",
              availableLanguage: ["English"],
            },
          },
          areaServed: [{ "@type": "Country", name: "Egypt" }],
          availableChannel: {
            "@type": "ServiceChannel",
            serviceUrl: "https://www.example.com/",
            availableLanguage: ["English", "Arabic"],
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What payment channels can I use to pay my Contact installments?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "You can pay your Contact installments easily through a wide range of payment channels and methods available nationwide: Use the ContactNow app for a fully digital experience, or pay through our trusted partners: Alahlymomken, InstaPay (Basata), Masary (Basata), Damen, Fawry, Opay, and Superpay. We’re also expanding our Contact payment channels to include Aman, Sahl, and Egypt Post, offering you even more payment options soon.",
              },
            },
            {
              "@type": "Question",
              name: "What is ContactNow, and how can I use it to pay my installments?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "ContactNow is the official app from Contact, designed to make digital installment payments faster and simpler. It gives you full control over your financing and insurance in one place! How to pay through ContactNow: Open the ContactNow app and log in, From the main dashboard, select ‘Pay Your Bills, Choose ‘Installments’ to view your outstanding balance, due dates, and payment history, Review payment details such as the amount due and the schedule, Choose your preferred payment method and confirm the amount, Complete the transaction and receive an instant digital payment receipt.",
              },
            },
            {
              "@type": "Question",
              name: "How can I pay my Contact installments through Fawry?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "You can easily pay through Fawry using the myFawry app or at Fawry Plus stores and partner retail outlets. Via myFawry Mobile App: Go to Payment Services > Financial and Banks > Installments > Contact. Choose your installment type (auto, education, mortgage, etc.). Enter your national ID number. Select your payment method (credit, debit, or prepaid card). Confirm and complete the transaction to receive instant payment confirmation. At Fawry Plus or Retail Network: Visit any outlet displaying the Fawry logo. Provide your national ID number to the cashier. Pay using cash, debit, credit, or prepaid card. Receive your payment receipt immediately. Note: Minimal transaction fees apply. Payments are reflected in your Contact account within one working day.",
              },
            },
            {
              "@type": "Question",
              name: "How can I use InstaPay to pay my Contact installments?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "You can make online installment payments in Egypt anytime with Instapay. Steps to pay via InstaPay: Open the InstaPay app and go to Bill Payment. Select Financial Services and choose Contact. Choose the type of installment you want to pay. Enter your national ID number and payment amount. Review the details and confirm using your IPN PIN. Note: If your payment is successful but not reflected, contact your bank with the transaction reference number.",
              },
            },
            {
              "@type": "Question",
              name: "Are there any new payment options coming soon?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes, we are always innovating to serve you better! Aman and Sahl will be live within the next two weeks (as of October 2025), and Egypt Post will be available soon after. These additions will make Contact payment options even more accessible nationwide. Stay tuned for official updates through our website and ContactNow app!",
              },
            },
            {
              "@type": "Question",
              name: "What should I do if my payment doesn’t go through or appears delayed?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "If your payment appears pending or delayed, here’s what to do: Immediate steps: Check your transaction status in the app (successful, rejected, or pending). Keep your digital or printed payment receipt for reference. Rejected payments are automatically reversed. If not, contact your bank. Contact Support: Reach us through WhatsApp, our Email, or call our hotline 16177. You can also visit any Contact branch for assistance.",
              },
            },
            {
              "@type": "Question",
              name: "Why should I choose Contact payment channels for paying installments?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Contact gives you the most diversified payment options in Egypt, ensuring convenience and trust. Unmatched Convenience: Pay anytime, anywhere through apps or over 500,000 physical outlets. All-in-One Experience: Manage financing, payments, and insurance in one platform with ContactNow. Digital Innovation: 24+ years of experience combined with leading e-collection payment solutions like Fawry and InstaPay. Trusted Legacy: Contact is a pioneer in non-banking financial services, backed by strong customer trust and innovation.",
              },
            },
          ],
        },
      ],
      slug: "payment-channels",
    },
    financing: {
      title: "Buy Your Car Now with Egypt's Lowest Finance Rate",
      meta_desc:
        "Finance your new car with CONTACT at 4.4% interest, 0% admin fees, 3 years free maintenance, and a 5-year warranty. Apply now and drive away sooner.",
    },
    ads: {
      title: "Achieve Your Dreams and More with Contact Today",
      meta_desc:
        "Everything you've dreamed of and more is within reach with Contact. Share your details and our team will reach out at a time that suits you best.",
    },
    campaign: {
      title: "Thank You for Contacting Contact | We'll Be in Touch",
      meta_desc:
        "Thank you for reaching out to Contact! We've received your details, and one of our representatives will contact you shortly to help make things happen.",
    },
  },

  Erroruploadingfile: "Error uploading file try again",
  connectionError:
    "Network issue detected. Please check your connection and try again.",
  branches: {
    hero: {
      title: "The Leading Financing Provider in {{branch}}",
      desc: "Enjoy hassle-free procedures and tailored installment plans for all Financing solutions with Contact.",
      cta: "Explore More",
      expertiseTitle: "Backed by over 20 years of expertise",
      expertiseDesc:
        "Contact goes above and beyond to provide comprehensive solutions, including insurance, savings, investments, and smart payment options, all designed to fit your lifestyle and budget.",
    },
    stats: {
      customers: "Customers Served",
      transactions: "Transactions",
      branches: "Branches",
      merchant: "Largest Merchant Network in Egypt",
      customersCount: 425000,
      transactionsCount: 750000,
      merchantCount: 18000,
      branchesCount: 60,
    },
    services: {
      title: "Services in Location",
      body: "The contact branch in {{branch}} offers the ultimate comprehensive financial services. With down payments starting at just 10% and financing up to 10 million EGP over 5 years, our team of experts is ready to assist you with a wide range of financial solutions. We handle the details, so you can relax and focus on what matters: your financial freedom. At the branch, we offer a variety of flexible installment plans where you’re free to choose the option that fits your needs and budget perfectly.",
      branchAlt: "Contact Branch",
    },
    why: {
      title: "Why Choose Contact {{branch}} Branch",
      lead: "At the Contact Branch in {{branch}}, we are at the forefront of enhancing our customer experience.",
      items: [
        "Over 20 years of trusted experience as one of Egypt’s top consumer finance providers.",
        "Customized financial solutions designed to support the {{branch}} community through every life stage.",
        "Fast approval processes tailored for {{branch}} residences.",
        "Comprehensive insurance plans to keep what matters most protected.",
        "Smart electronic payment services for fast, secure, and convenient transactions.",
        "Powered by decades of expertise in finance and insurance innovation.",
      ],
    },
    about: {
      paragraphs: [
        "Contact is proud to be part of the vibrant and growing community of {{branch}}, an area celebrated for its beautifully planned surroundings, modern infrastructure, and diverse, dynamic residents.",
        "Our conveniently located branch is here to provide you with a full range of financial services tailored to your lifestyle.",
        "Whether you’re looking for flexible auto financing, comprehensive insurance solutions, or smart payment services, our team is ready to assist you with personalized support and trusted expertise.",
        "We’re more than just a finance provider; we’re your partner in achieving financial freedom and stability, right in the heart of your community.",
      ],
    },
    steps: {
      defaultSteps: [
        {
          number: "01",
          title: "Visit the {{branch}} Branch",
          Icon: "/apartment.svg",
        },
        {
          number: "02",
          title: "Discuss your inquiries",
          Icon: "/question.svg",
        },
        {
          number: "03",
          title: "Submit any necessary documents",
          Icon: "/submit.svg",
        },
        {
          number: "04",
          title: "Get approval for your inquiries",
          Icon: "/verified.svg",
        },
      ],
    },
    cursuror: {
      title: "Specific Services Offered at {{branch}} Branch",
      items: [
        {
          title: "Auto Finance",
          subtitle: "Over 24 years of expertise in car financing",
          features: [
            "Over 24 years of expertise in car financing",
            "More than 7 installment plans",
            "New, used, and electric cars",
          ],
          icon: "/services/car.svg",
          url: "/products/auto",
        },
        {
          title: "Motorcycle",
          subtitle: "Financing all the brands",
          features: [
            "Financing all the brands",
            "Most flexible payment plans",
            "Highest financing value",
          ],
          icon: "/services/motorcycle.svg",
          url: "/products/motorcycles",
        },
        {
          title: "Trucks",
          subtitle: "Installment plans for individuals and business owners",
          features: [
            "Installment plans for individuals and business owners",
            "Most flexible payment plan",
            "Highest financing value",
          ],
          icon: "/services/lorry.svg",
          url: "/products/trucks",
        },
        {
          title: "Home Furniture",
          subtitle: "Combine multiple price offers in one request",
          features: [
            "Possibility of combining multiple price offers in the same request",
            "Most flexible payment plans",
            "Highest financing value",
          ],
          icon: "/services/home-furniture.svg",
          url: "/products/home-furniture",
        },
        {
          title: "Home Interior",
          subtitle: "Finish your home in your own style",
          features: [
            "Finish your home in your own style",
            "Most flexible payment plans",
            "Highest financing value",
          ],
          icon: "/services/design.svg",
          url: "/products/home-interior",
        },
        {
          title: "Green Finance",
          subtitle: "Fund solar panels, greenhouses, and more",
          features: [
            "Highest financing value",
            "Different payment plans to suit your capabilities",
            "Financing solar panels, agricultural greenhouses, and everything your project needs",
          ],
          icon: "/services/green-finance.svg",
          url: "/products/green-finance",
        },
        {
          title: "Mortgage",
          subtitle: "Finance the house you’ve always dreamt of",
          features: [
            "Financing the house you’ve always dreamt of",
            "Most flexible payment plan",
            "Highest financing value",
          ],
          icon: "/services/house.svg",
          url: "/products/mortgage",
        },
        {
          title: "Manasik (Hajj & Umrah)",
          subtitle: "Start your sacred journey to the holy land",
          features: [
            "Achieve your dream and start your sacred journey to the holy land",
            "Shariah compliant financing",
            "Most flexible payment plans",
          ],
          icon: "/services/manasik.svg",
          url: "/products/travel-and-tourism",
        },
        {
          title: "Clubs",
          subtitle: "Immediate activation of membership",
          features: [
            "Immediate activation of membership",
            "Installments for all clubs’ memberships",
            "No down payment",
          ],
          icon: "/services/clubs.svg",
          url: "/products/clubs",
        },
        {
          title: "Education",
          subtitle: "Installments for all education stages",
          features: [
            "Installments of all education stages, whether for your children or for yourself",
            "No down payment",
            "Highest financing value for education",
          ],
          icon: "/services/education.svg",
          url: "/products/education",
        },
        {
          title: "Watercrafts",
          subtitle: "Finance all types and brands of watercrafts",
          features: [
            "Financing all types and brands of watercrafts",
            "Most flexible payment plan",
            "You will have an outstanding experience at the sea",
          ],
          icon: "/services/watercraft.svg",
          url: "/products/watercraft",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          q: "What are the opening hours for the Contact {{branch}} branch?",
          a: "Our {{branch}} branch is open daily from 9:30 AM to 5:30 PM (except Friday and Saturday).",
        },
        {
          q: "What documents should I bring with me?",
          a: "To expedite your service, we recommend bringing your National ID. Our advisors at the branch will inform you of any other specific documents needed based on the service required.",
        },
        {
          q: "Do I need to make an appointment to visit the {{branch}} branch?",
          a: "Appointments are not required. Please feel free to visit us anytime during our operating hours.",
        },
      ],
    },
    footer: {
      title: "Your trusted financial partner in {{branch}}. ",
      description1: "Fast service. Flexible plans. Real solutions.",
      description2: "Stop by today and let’s get started! ",
      callUS: "Call Us Now ",
    },
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "FinancialService",
        name: "Contact - {{branch}} Branch",
        description:
          "Visit the Contact {{branch}} branch for all your financing needs. Find our full address, opening hours, and a wide range of installment plans. Call us at 16177.",
        url: "https://contact.eg/en/branches/{{branch}}",
        telephone: "+2016177",
        address: {
          "@type": "PostalAddress",
          streetAddress: "{{address}}",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "{{lat}}",
          longitude: "{{long}}",
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
            opens: "09:30",
            closes: "17:30",
          },
        ],
        image: "https://contact.eg/path/to/logo.png",
        sameAs: [
          "https://www.facebook.com/ContactEgy",
          "https://www.linkedin.com/company/contact-financial-holding",
        ],
      },
    ],
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What are the opening hours for the Contact.eg {{branch}} branch?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our {{branch}} branch is open daily from 9:30 AM to 5:30 PM (except Friday and Saturday)",
          },
        },
        {
          "@type": "Question",
          name: "What documents should I bring with me?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "To expedite your service, we recommend bringing your National ID. Our advisors at the branch will inform you of any other specific documents needed based on the service required.",
          },
        },
        {
          "@type": "Question",
          name: "Do I need to make an appointment to visit the {{branch}} branch?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Appointments are not required. Please feel free to visit us anytime during our operating hours.",
          },
        },
      ],
    },
  },
};
